import Axios from "axios";

const BASE_URL = `${import.meta.env.VITE_BASE_URL_API_BACKEND}/overview-metrics`;

export default class overviewMetricService {
  static get = async (params) => {
    try {
      const { data } = await Axios.get(BASE_URL, { params });
      return data;
    } catch {
      return false;
    }
  };

  static getById = async (id) => {
    try {
      const { data } = await Axios.get(`${BASE_URL}/${id}`);
      return data;
    } catch {
      return false;
    }
  };

  static post = async (payload) => {
    try {
      const { data } = await Axios.post(BASE_URL, payload);
      return data;
    } catch {
      return false;
    }
  };

  static put = async (id, payload) => {
    try {
      const { data } = await Axios.put(`${BASE_URL}/${id}`, payload);
      return data;
    } catch {
      return false;
    }
  };

  static delete = async (id) => {
    try {
      await Axios.delete(`${BASE_URL}/${id}`);
      return true;
    } catch {
      return false;
    }
  };
}
